import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import { TypographyWithEllipsisTooltip } from '../TypographyWithEllipsisTooltip';

const getStyles = (noWrap) => ({
  actionsRoot: {
    '& button': {
      '& span': {
        ml: {
          sm: -0.5,
          xs: 0,
        },
        mr: {
          sm: 1,
          xs: 0,
        },
      },
      '& svg': {
        height: '24px',
        width: '24px',
      },
      height: '47px',
      minWidth: 'fit-content',
    },
    paddingRight: '0 !important',
  },
  rightSide: {
    paddingRight: '0 !important',
    pt: noWrap ? '0 !important' : undefined,
    whiteSpace: noWrap ? 'nowrap' : 'normal',
  },
  root: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: 3.5,
  },
});

const Title = ({ heading, leftSide, noWrap, rightSide, rightSideActions }) => {
  const styles = getStyles(noWrap);
  const flexWrap = noWrap ? 'nowrap' : undefined;
  const minWidth = noWrap ? '1px' : undefined;

  return (
    <Grid container spacing={2} sx={styles.root} flexWrap={flexWrap}>
      <Grid container item sm xs={10} flexWrap={flexWrap} minWidth={minWidth}>
        {leftSide && <Grid item>{leftSide}</Grid>}
        <Grid item minWidth={minWidth}>
          <TypographyWithEllipsisTooltip component="div" paragraph variant="h4">
            {heading}
          </TypographyWithEllipsisTooltip>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container item spacing={2}>
          {rightSide && (
            <Grid item sx={styles.rightSide}>
              {rightSide}
            </Grid>
          )}
          {rightSideActions && (
            <Grid item sx={styles.actionsRoot}>
              {rightSideActions}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

Title.propTypes = {
  heading: PropTypes.any.isRequired,
  leftSide: PropTypes.any,
  noWrap: PropTypes.bool,
  rightSide: PropTypes.any,
  rightSideActions: PropTypes.any,
};

export default Title;
